import { render, staticRenderFns } from "./ReworksSuperAdminPreSelect.vue?vue&type=template&id=2f87dea0"
import script from "./ReworksSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./ReworksSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports